"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _i18next = _interopRequireDefault(require("i18next"));

var _reactI18next = require("react-i18next");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var IntlProvider = function IntlProvider(_a) {
  var children = _a.children,
      _b = _a.lng,
      lng = _b === void 0 ? 'en-us' : _b,
      _c = _a.lowerCaseLng,
      lowerCaseLng = _c === void 0 ? true : _c,
      _d = _a.fallbackLng,
      fallbackLng = _d === void 0 ? 'en-us' : _d,
      _e = _a.debug,
      debug = _e === void 0 ? false : _e,
      resources = _a.resources;

  _i18next["default"].use(_reactI18next.initReactI18next).init({
    resources: resources,
    lng: lng,
    lowerCaseLng: lowerCaseLng,
    fallbackLng: fallbackLng,
    debug: debug
  });

  return _react["default"].createElement(_reactI18next.I18nextProvider, {
    i18n: _i18next["default"]
  }, children);
};

var _default = IntlProvider;
exports["default"] = _default;